import { Reveal } from "./Reveal";
import { scrollToId } from "../../lib/contact";

export const Intro = () => (
  <section id="about" data-testid="intro-section" className="py-24 sm:py-28 bg-white">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-electric">About LaunchX Academy</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy leading-[1.15]">
          More Than a Regular Digital Marketing Course
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mt-6 text-base sm:text-lg text-slate-500 leading-relaxed">
          LaunchX Academy teaches you how an online business actually works — from selecting an opportunity and creating an offer to generating customers, managing operations and calculating profit.
        </p>
      </Reveal>
      <Reveal delay={0.22}>
        <p className="mt-4 text-base text-slate-500 leading-relaxed">
          Students don't just learn individual tools. They understand how to combine websites, advertising, content, marketplaces, sales and operations to build a <span className="font-semibold text-navy">complete online business system</span>.
        </p>
      </Reveal>
      <Reveal delay={0.28}>
        <div className="mt-9 inline-flex flex-col sm:flex-row items-center gap-4 bg-background border border-slate-200 rounded-2xl px-7 py-5">
          <p className="font-display font-semibold text-navy text-sm sm:text-base">
            Explore <span className="text-electric">five online business models</span> — then select one for your final practical project.
          </p>
          <button data-testid="intro-cta" onClick={() => scrollToId("models")} className="text-sm font-semibold text-electric hover:text-electric-dark shrink-0">
            See the Models →
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
